import { NotifyHelper } from "../../../helpers/toast";
import { eAccMonKhongTinhHocPhiActionsObj } from "../../action-types/category/IMonKhongTinhHocPhiActions";
import { generateActionForKey, generateActions } from "../generateActions";

export const monKhongTinhHocPhiActions = {
  ...generateActions(
    eAccMonKhongTinhHocPhiActionsObj,
    "MON_KHONG_TINH_HOC_PHI",
  ),
  ...generateActionForKey(
    eAccMonKhongTinhHocPhiActionsObj,
    "MON_KHONG_TINH_HOC_PHI",
    "SAVE_SUCCESS",
    () => {
      NotifyHelper.Success("Đã cập nhật");
    },
  ),
  ...generateActionForKey(
    eAccMonKhongTinhHocPhiActionsObj,
    "MON_KHONG_TINH_HOC_PHI",
    "SAVE_ERROR",
    (m: string) => {
      NotifyHelper.Error(m);
    },
  ),
  ...generateActionForKey(
    eAccMonKhongTinhHocPhiActionsObj,
    "MON_KHONG_TINH_HOC_PHI",
    "DELETE_SUCCESS",
    () => {
      NotifyHelper.Success("Đã xóa");
    },
  ),
  ...generateActionForKey(
    eAccMonKhongTinhHocPhiActionsObj,
    "MON_KHONG_TINH_HOC_PHI",
    "DELETE_ERROR",
    (m: string) => {
      NotifyHelper.Error(m);
    },
  ),
};
